import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
import '@/assets/styles/style.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import sentry from '@/services/sentry'
import App from './App.vue'
import globalComponents from './components'
import globalDirectives from './directives'
import router from './routes'

const pinia = createPinia()

createApp(App)
  .use(pinia)
  .use(router)
  .use(sentry, router, pinia)
  .use(globalComponents)
  .use(globalDirectives)
  .mount('#app')
